import { parsePhoneNumber } from 'libphonenumber-js';

/**
 * Format a phone number string into its international representation.
 * Returns the original string when parsing fails.
 */
export function formatPhoneNumber(number: string): string {
    try {
        const phone = parsePhoneNumber(number);
        return phone ? phone.formatInternational() : number;
    } catch {
        return number;
    }
}
